<template>
  <div class="text-center">
    <OnexDialog
      :type="type"
      :is-persistent="isPersistent"
      v-model="showDialog"
      max-width="480"
      :show-close-button="showCloseButton"
      class="aboveDialog"
    >
      <template #title>
        <span v-html="title" />
      </template>
      <template #text>
        <span v-html="message" :class="messageAlign === 'center' ? 'text-center' : ''" />
        <slot name="message"></slot>
      </template>
      <template #yesBtn>
        <span @click="buttonOneAction">{{ buttonOneLabel }}</span>
      </template>
      <template #noBtn v-if="hasButtonTwo">
        <span @click="buttonTwoAction">{{ buttonTwoLabel }}</span>
      </template>
    </OnexDialog>
  </div>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import {
  mdiAlert,
  mdiAlertCircleOutline,
  mdiCheckCircleOutline,
  mdiInformationOutline,
} from '@mdi/js';
import { OnexDialog } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'MessageDialog',
  components: {
    OnexDialog,
  },
  data() {
    return {
      showContinue: true,
      mdiAlert,
      mdiAlertCircleOutline,
      mdiInformationOutline,
      mdiCheckCircleOutline,
    };
  },
  props: {
    showCloseButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    showDialog: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: 'error',
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    message: {
      type: String,
      required: false,
      default: '',
    },
    messageAlign: {
      type: String,
      required: false,
      default: '',
    },
    hasButtonTwo: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonOneLabel: {
      type: String,
      required: false,
      default: 'OK',
    },
    buttonTwoLabel: {
      type: String,
      required: false,
      default: '',
    },
    isPersistent: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    buttonTwoAction() {
      this.$emit('buttonTwoAction');
    },
    buttonOneAction() {
      this.$emit('buttonOneAction');
    },
    hasSlot(name = 'message') {
      return !!this.$slots[name];
    },
  },
  computed: {
    border() {
      if (this.type === 'error') {
        return 'errorBorder';
      } else if (this.type === 'warning') {
        return 'warningBorder';
      } else if (this.type === 'success') {
        return 'successBorder';
      } else if (this.type === 'info') {
        return 'infoBorder';
      }
      return '';
    },
    iconColor() {
      if (this.type === 'error') {
        return 'error';
      } else if (this.type === 'warning') {
        return 'warning';
      } else if (this.type === 'success') {
        return 'success';
      } else if (this.type === 'info') {
        return 'info';
      }
      return '';
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss">
.minButtonSize {
  min-width: 120px;
}
.leftalignment {
  border-top: 7px solid #ee7026 !important;
}
.warningBorder {
  border-top: 7px solid #ee7026 !important;
}
.infoBorder {
  border-top: 7px solid #2196f3 !important;
}
.successBorder {
  border-top: 7px solid #0b8d1f !important;
}
.errorBorder {
  border-top: 7px solid #dd3333 !important;
}
.aboveDialog {
  z-index: 10001 !important;
}
</style>
